import { render } from "./App.vue?vue&type=template&id=6dccca3b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6dccca3b&lang=css"

import exportComponent from "/Users/a123/Documents/HBuilderProjects/limit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__